// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"RoomOptionsLayout__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/layouts/RoomOptionsLayout/RoomOptionsLayout.scss
 ** module id = 960
 ** module chunks = 1
 **/